import { MessageCircle } from "lucide-react";
import { site } from "../content";
import { waLink, trackWhatsAppClick } from "../lib/whatsapp";

export default function WhatsAppFloat() {
  return (
    <>
      <a
        href={waLink(site.messages.floating)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-floating-button"
        onClick={() => trackWhatsAppClick("floating", "Botão flutuante WhatsApp")}
        aria-label="Falar no WhatsApp sobre o Barber Steamer"
        className="animate-pulse-ring fixed bottom-6 right-6 z-[70] hidden h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.35)] transition-transform duration-300 hover:scale-110 md:flex"
      >
        <MessageCircle className="h-6 w-6" fill="currentColor" aria-hidden="true" />
      </a>

      <div className="fixed inset-x-0 bottom-0 z-[70] md:hidden" data-testid="whatsapp-mobile-bar">
        <a
          href={waLink(site.messages.floating)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWhatsAppClick("mobile_bar", "Quero conhecer o Barber Steamer")}
          className="flex h-14 items-center justify-center gap-2.5 bg-gold font-display text-sm font-black uppercase tracking-[0.15em] text-ink shadow-[0_-8px_30px_rgba(0,0,0,0.45)]"
        >
          <MessageCircle className="h-5 w-5" aria-hidden="true" />
          Quero conhecer o Barber Steamer
        </a>
      </div>
    </>
  );
}
